import { MessageCircle } from "lucide-react";

export const WhatsappFloat = () => {
  const handleWhatsappClick = () => {
    window.open('https://wa.me/5561998379503', '_blank');
  };

  return (
    <button
      onClick={handleWhatsappClick}
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 z-50 group"
      aria-label="Fale conosco no WhatsApp"
    >
      <MessageCircle className="h-6 w-6" />
      
      {/* Tooltip */}
      <span className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Fale Conosco
      </span>

      {/* Pulse Animation */}
      <span className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-75"></span>
    </button>
  );
};